import { defineComponent, ref, watch } from "vue";
import Button from "../../share/button";
import Input from "../../share/input";
import message from "../../share/message";
import Popup from "../../share/popup";
import type { NebulaWEBGameSDKAccount } from "../../../account";
import type { PropType } from "vue";

import "./captcha.less";

export default defineComponent({
  emits: ["confirm", "cancel"],
  props: {
    visible: { type: Boolean, default: false },
    mobile: { type: String, default: "" },
    service: { type: Object as PropType<NebulaWEBGameSDKAccount>, required: true },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const captchaImage = ref("");
    const captchaValue = ref("");

    const onRefreshClick = async () => {
      if (loading.value) return;
      loading.value = true;
      const result = await props.service.requestGenerateCaptcha({ mobile: props.mobile });
      loading.value = false;
      if (result.status === "error") {
        message.info({ message: result.msg });
      }
      captchaImage.value = result.data!.captcha;
      captchaValue.value = "";
    };

    const onCancelClick = () => {
      emit("cancel");
    };

    const onSubmitClick = async () => {
      if (!captchaValue.value) {
        message.info({ message: "请输入图中验证码" });
        return;
      }
      if (captchaValue.value.length !== 4) {
        message.info({ message: "请输入有效的验证码" });
        return;
      }
      const result = await props.service.requestVerifyCaptcha({
        mobile: props.mobile,
        code: captchaValue.value,
      });
      if (result.status === "error") {
        captchaValue.value = "";
        void onRefreshClick();
        message.info({ message: result.msg });
        return;
      }
      emit("confirm");
    };

    watch(
      () => props.visible,
      () => {
        if (!props.visible) return;
        captchaValue.value = "";
        captchaImage.value = "";
        void onRefreshClick();
      },
    );

    return () => (
      <Popup closeOnOverlayClick={false} position="center" visible={props.visible} width={320}>
        <div class="feiyu-web-service-login-captcha">
          <div class="feiyu-web-service-login-captcha--title">{"请输入图中验证码"}</div>
          <div class="feiyu-web-service-login-captcha--code" onClick={() => void onRefreshClick()}>
            <img
              alt="图形验证码"
              class="feiyu-web-service-login-captcha--code-image"
              src={captchaImage.value}
              v-show={!!captchaImage.value}
            />
          </div>
          <div
            class="feiyu-web-service-login-captcha--refresh"
            onClick={() => void onRefreshClick()}
          >
            {"看不清？点此换一张"}
          </div>
          <div class="feiyu-web-service-login-captcha--input">
            <Input maxLength={4} placeholder="请输入图中验证码" v-model={captchaValue.value} />
          </div>

          <div class="feiyu-web-service-login-captcha--action">
            <Button disabled={loading.value} onClick={onCancelClick}>
              {"取消"}
            </Button>
            <Button loading={loading.value} type="primary" onClick={onSubmitClick}>
              {"确定"}
            </Button>
          </div>
        </div>
      </Popup>
    );
  },
});
